import React from 'react'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'
import Seo from '../../../components/seo'
import {THEME_COLOR} from '../../../constants'
import {useBrand, toBrandCode} from '../../../contexts/brand-context'

const AppSeo = () => {
    const {brandId} = useBrand()
    const brandSuffix = toBrandCode(brandId)

    return (
    <Seo>
        <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1" />
        <meta name="theme-color" content={THEME_COLOR} />
        {/* Favicons for all devices */}
        <link
            rel="icon"
            type="image/x-icon"
            href={getAssetUrl(`static/ico/16x16_favicon_${brandSuffix}.ico`)}
            sizes="16x16"
        />
        <link
            rel="icon"
            type="image/x-icon"
            href={getAssetUrl(`static/ico/32x32_favicon_${brandSuffix}.ico`)}
            sizes="32x32"
        />
        <link
            rel="icon"
            type="image/x-icon"
            href={getAssetUrl(`static/ico/48x48_favicon_${brandSuffix}.ico`)}
            sizes="48x48"
        />
        <link
            rel="apple-touch-icon"
            href={getAssetUrl('static/img/global/apple-touch-icon.png')}
            sizes="180x180"
        />
        <link rel="manifest" href={getAssetUrl('static/manifest.json')} />
        <link rel="stylesheet" type="text/css" href={getAssetUrl('static/global.css')} />
    </Seo>
    )
}

export default AppSeo
